import { createContext } from "react";
import { API_BASE_URL } from "../config";

export type SettingsModel = {
  widget_name: string;
  endpoint?: string;
  matomo_container: string;
  share_url: string;
  pre_filters?: PreFilterModel | undefined;
  page_title: string;
  show_header_footer: boolean;
  county_label: string,
  x_api_key: string,
  countries: { label:string, value:string }[],
  show_pdf_download: boolean
};

export type PreFilterModel = {
  county?: string;
  month?: string;
  crop?: string;
};

export const getDefaultSettings = (data: any): SettingsModel => ({
  widget_name: data.widget_name || "prise-bulletin",
  endpoint: data.endpoint || API_BASE_URL,
  matomo_container: data.matomo_container,
  share_url: data.share_url,
  pre_filters: data.pre_filters || undefined,
  page_title: data.page_title || "Malawi Pest Risk Bulletins",
  show_header_footer: data.show_header_footer ?? true,
  county_label: data.county_label || 'District (Optional)',
  x_api_key: data.x_api_key || undefined,
  countries : data.countries || [ { label: "Malawi", value: "malawi" }],
  show_pdf_download: data.show_pdf_download || false
});

const SettingsContext = createContext<SettingsModel | undefined>(undefined);
export const SettingsProvider = SettingsContext.Provider;
export default SettingsContext;
